
import React from "react"

const sectionh_content_above_field_6 = () => (
    <div style={{
        'padding': '0 18px 18px 18px',
    }}>
        <small>A. <strong>Displacement</strong>: An H-1B dependent or willful violator employer is prohibited from displacing a U.S. worker in its own workforce within the period beginning 90 days before and ending 90 days after the date of filing of the visa petition. 20 CFR 655.738(c);</small><br/>
        <small>B. <strong>Secondary Displacement</strong>: An H-1B dependent or willful violator employer is prohibited from placing an H-1B nonimmigrant worker(s) with another/secondary employer where there are indicia of an employment relationship between the nonimmigrant worker(s) and that other/secondary employer (thus possibly affecting the jobs of U.S. workers employed by that other employer), unless and until the employer subject to this LCA makes the inquiries and/or receives the information set forth in 20 CFR 655.738(d)(5) concerning that other/secondary employer’s displacement of similarly employed U.S. workers in its workforce within the period beginning 90 days before and ending 90 days after the date of such placement. 20 CFR 655.738(d). Even if the required inquiry of the secondary employer is made, the H-1B dependent or willful violator employer will be subject to a finding of a violation of the secondary displacement prohibition if the secondary employer, in fact, displaces any U.S. worker(s) during the applicable time period; and</small><br/>
        <small>C. <strong>Recruitment and Hiring</strong>: Prior to filing this LCA or any petition or request for extension of status for nonimmigrant worker(s)supported by this LCA, the H-1B dependent or willful violator employer must take good faith steps to recruit U.S. workers for the job(s) using procedures that meet industry-wide standards and offer compensation that is at least as great as the required wage to be paid to the nonimmigrant worker(s) pursuant to 20 CFR 655.731(a). The employer must offer the job(s) to any U.S. worker who applies and is equally or better qualified for the job than the nonimmigrant worker. 20 CFR 655.739.</small><br/>
    </div>

)

/**
 * contentInsertion: inserts content in between fields in a hardcoded manner
 * as this goes against the pattern that is currently est. 
 * 
 * set the content ABOVE the field with the passed in code and label
 * 
 * Currently in use for the 9035 form.
 */
const contentInsertion = (title, code) => {
    let key = `${title}_${code}`
    let resolver = {
        "H-1B Additional Employer Labor Condition Statements_6." : sectionh_content_above_field_6
    }

    return resolver[key] || (() => <div/>)
}

export default contentInsertion

